import { render, staticRenderFns } from "./AuditLogsView.vue?vue&type=template&id=d5745132&scoped=true"
import script from "./AuditLogsView.vue?vue&type=script&lang=js"
export * from "./AuditLogsView.vue?vue&type=script&lang=js"
import style0 from "./AuditLogsView.vue?vue&type=style&index=0&id=d5745132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5745132",
  null
  
)

export default component.exports